import type { Environment } from '../../lib/trajectory/types';

interface EnvironmentControlsProps {
  env: Environment;
  rangeYards: number;
  onEnvChange: (next: Environment) => void;
  onRangeChange: (next: number) => void;
}

export function EnvironmentControls({
  env,
  rangeYards,
  onEnvChange,
  onRangeChange,
}: EnvironmentControlsProps) {
  return (
    <div className="environment-controls">
      <h3>Environment</h3>
      <div className="picker-row">
        <label>Range (yards)</label>
        <input
          type="range"
          value={rangeYards}
          step={5}
          min={20}
          max={100}
          onChange={(e) => onRangeChange(Number(e.target.value))}
        />
        <span className="range-value">{rangeYards}y</span>
      </div>
      <div className="picker-row">
        <label>Wind (mph)</label>
        <input
          type="range"
          value={env.windMph}
          step={1}
          min={0}
          max={30}
          onChange={(e) => onEnvChange({ ...env, windMph: Number(e.target.value) })}
        />
        <span>{env.windMph} mph</span>
      </div>
      <div className="picker-row">
        <label>Wind angle (°)</label>
        <input
          type="range"
          value={env.windAngleDeg}
          step={5}
          min={0}
          max={360}
          onChange={(e) => onEnvChange({ ...env, windAngleDeg: Number(e.target.value) })}
        />
        <span>{env.windAngleDeg}°</span>
      </div>
      <div className="picker-row">
        <label>Altitude (ft)</label>
        <input
          type="number"
          value={env.altitudeFt}
          step={500}
          min={0}
          max={14000}
          onChange={(e) => onEnvChange({ ...env, altitudeFt: Number(e.target.value) })}
        />
      </div>
      <div className="picker-row">
        <label>Shot elevation (°)</label>
        <input
          type="range"
          value={env.shotElevationDeg}
          step={5}
          min={-45}
          max={45}
          onChange={(e) => onEnvChange({ ...env, shotElevationDeg: Number(e.target.value) })}
        />
        <span>{env.shotElevationDeg}°</span>
      </div>
      <div className="picker-row">
        <label>Brush at (yards)</label>
        <input
          type="number"
          value={env.brushAtYards ?? ''}
          step={5}
          min={5}
          max={100}
          placeholder="off"
          onChange={(e) => {
            const v = e.target.value === '' ? undefined : Number(e.target.value);
            onEnvChange({ ...env, brushAtYards: v });
          }}
        />
      </div>
      <div className="picker-row">
        <label>Brush height (in)</label>
        <input
          type="number"
          value={env.brushHeightIn ?? ''}
          step={1}
          min={0}
          max={48}
          placeholder="off"
          onChange={(e) => {
            const v = e.target.value === '' ? undefined : Number(e.target.value);
            onEnvChange({ ...env, brushHeightIn: v });
          }}
        />
      </div>
    </div>
  );
}
